/**
 * Minimal company fields for flows that need carrier display preferences alongside the name.
 * When `settings` is null or partial, resolve defaults with makeCompanySettings (MDY + twelveHour).
 */
export const COMPANY_NAME_AND_SETTINGS_FIELDS = ['name', 'settings'];

/** User.company join fragment for appointment/user loads that need display prefs. */
export const COMPANY_NAME_AND_SETTINGS_JOIN = 'company||name,settings';
